import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function TableRow(props, context) {
  const { className: classNameProp, component: Component, hover, selected, ...other } = props;

  const className = classNames(classNameProp, { 'is-active': selected }, { 'has-hover': hover });

  return <Component className={className} {...other} />;
}

TableRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  hover: PropTypes.bool,
  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool,
};

TableRow.defaultProps = {
  component: 'tr',
  selected: false,
};

TableRow.contextTypes = {
  table: PropTypes.object,
};

export default TableRow;
